import { render } from "./CreDashboard.vue?vue&type=template&id=91e020ac&scoped=true"
import script from "./CreDashboard.vue?vue&type=script&lang=js"
export * from "./CreDashboard.vue?vue&type=script&lang=js"

import "./CreDashboard.vue?vue&type=style&index=0&id=91e020ac&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91e020ac"]])

export default __exports__